import React, {useEffect, useContext} from 'react'
import {Button} from 'antd'
import {useHistory} from "react-router-dom";
import {sideMenuContext} from "../../../router/IndexRouter";
import {Arguments} from "../common/Arguments";
import {GetApiMethod} from "../common/ApiMethod";
import TableComponent from "../common/TablePaginationComponent";
import EditComponent from "../common/EditComponent";
import DeleteComponent from "../common/DeleteComponent";
import SearchBox from "../common/SearchBoxComponent";


export default function InformationDeliveryAdmin(props) {
    const currentUrl = window.location.href;
    const {setCurrentItem} = useContext(sideMenuContext)
    const history = useHistory();
    const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
    const getApi = Arguments.host + "/society_organization/policy/api!informationDelivery.do";

    useEffect(() => {
        setDataSource([]);
        GetApiMethod({getApi, setDataSource, setCopyDataSource});
    }, [getApi])

    const handleTitleClick = (item) => {
        history.push(`/system/information-delivery-admin/${item.notificationId}`);
        setCurrentItem(item);
    };

    const columns = [
        {
            title: '序号',
            dataIndex: 'showIndex',
            width: 100,
            sorter: (a, b) => a.showIndex - b.showIndex,
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '标题',
            dataIndex: 'title',
            render: (title, item) => (
                <Button type="link" onClick={() => {
                    handleTitleClick(item)
                }}><b>{title}</b></Button>
            )
        },
        {
            title: '发布日期',
            dataIndex: 'publishDate',
            width: 140,
            sorter: (a, b) => a.publishDate.localeCompare(b.publishDate),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: '是否有效',
            dataIndex: 'status',
            width: 140,
            sorter: (a, b) => a.status.localeCompare(b.status),
            sortDirections: ["ascend", "descend"]
        },
        {
            title: "操作",
            width: 140,
            render: (item) => (
                <>
                    <EditComponent item={item} url={currentUrl}/>
                    <DeleteComponent
                        item={item}
                        postApi={[Arguments.host + "/society_organization/policy/api!addInformation.do"]}
                        getApi={getApi}
                    />
                </>
            )
        }
    ];

    const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}))

    return (
        <>
            <Button type="primary" onClick={() => props.history.push("/system/information-delivery-admin/add")}
                    style={{marginBottom: 10}}>新增</Button>
            <SearchBox placeholder="输入标题关键字"/>
            <TableComponent dataSource={indexDataSource} columns={columns}/>
        </>
    )
}






